import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { BackgroundImage } from './BackgroundImage.tsx';

const SpinnerContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    textAlign: 'center'
});

const LoadingContent = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    width: '100%'
});

interface LoadingSpinnerProps {
    message?: string;
    size?: number;
    showBackground?: boolean;
    showMessage?: boolean;
    color?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    message = 'Loading...',
    size = 88,
    showBackground = true,
    showMessage = false,
    color = 'primary.main'
}) => {
    const spinner = (
        <SpinnerContainer>
            <CircularProgress
                size={size}
                thickness={5}
                sx={{
                    color: color,
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                        stroke: color
                    }
                }}
            />
            {showMessage && message && (
                <Typography variant="h6" sx={{ color: color, fontWeight: 300 }}>
                    {message}
                </Typography>
            )}
        </SpinnerContainer>
    );

    if (!showBackground) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 200
                }}
            >
                {spinner}
            </Box>
        );
    }

    return (
        <BackgroundImage
            variant="login"
            overlay
            overlayColor="#000000"
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999
            }}
        >
            <LoadingContent>{spinner}</LoadingContent>
        </BackgroundImage>
    );
};
